export const users= [
    {
      id: 1,
      avatar: "/static/img/user-1.jpg",
      name: "Gavin Fletcher",
      designation: "Freelance Designer, Previously TapQ",
      about:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem necessitatibus natus fugit porro at sunt mollitia repellendus deserunt, libero similique.",
      gallery:[
        "/static/img/user-1.jpg",
        "/static/img/user-2.jpg",
        "/static/img/user-3.jpg",
        "/static/img/user-4.jpg"

      ],
      status:"badge-success"
    },
    {
      id: 2,
      avatar: "/static/img/user-2.jpg",
      name: "Isaac Roberts",
      designation: "Dekstop Engg.",
      about:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem necessitatibus natus fugit porro at sunt mollitia repellendus deserunt, libero similique.",
        gallery:[
          "/static/img/user-1.jpg",
          "/static/img/user-2.jpg",
          "/static/img/user-3.jpg",
          "/static/img/user-4.jpg"
  
        ],
        status:"badge-info"
    },
    {
      id: 3,
      avatar: "/static/img/user-3.jpg",
      name: "Sue Phelps",
      designation: "Network Adminstrator",
      about:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem necessitatibus natus fugit porro at sunt mollitia repellendus deserunt, libero similique.",
        gallery:[
          "/static/img/user-1.jpg",
          "/static/img/user-2.jpg",
          "/static/img/user-3.jpg",
          "/static/img/user-4.jpg"
  
        ],
        status:"badge-warning"
    },
    {
      id: 4,
      avatar: "/static/img/user-4.jpg",
      name: "Tillie Mason",
      designation: "Software Engg.",
      about:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem necessitatibus natus fugit porro at sunt mollitia repellendus deserunt, libero similique.",
        gallery:[
          "/static/img/user-1.jpg",
          "/static/img/user-2.jpg",
          "/static/img/user-3.jpg",
          "/static/img/user-4.jpg"
  
        ],
        status:"badge-danger"
    },
    {
      id: 5,
      avatar: "/static/img/user-5.jpg",
      name: "Anne Huff",
      designation: "UI Developer",
      about:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem necessitatibus natus fugit porro at sunt mollitia repellendus deserunt, libero similique.",
        gallery:[
          "/static/img/user-1.jpg",
          "/static/img/user-2.jpg",
          "/static/img/user-3.jpg",
          "/static/img/user-4.jpg"
  
        ],
        status:"badge-danger"
    },
    {
      id: 6,
      avatar: "/static/img/user-6.jpg",
      name: "Henry Houston",
      designation: "Freelance Designer, Previously TapQ",
      about:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem necessitatibus natus fugit porro at sunt mollitia repellendus deserunt, libero similique.",
      gallery:[
        "/static/img/user-1.jpg",
        "/static/img/user-2.jpg",
        "/static/img/user-3.jpg",
        "/static/img/user-4.jpg"

      ],
      status:"badge-success"
    },
    {
      id: 7,
      avatar: "/static/img/user-7.jpg",
      name: "Steven Haynes",
      designation: "UX Designer",
      about:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem necessitatibus natus fugit porro at sunt mollitia repellendus deserunt, libero similique.",
        gallery:[
          "/static/img/user-1.jpg",
          "/static/img/user-2.jpg",
          "/static/img/user-3.jpg",
          "/static/img/user-4.jpg"
  
        ],
        status:"badge-success"
    },
    {
      id: 8,
      avatar: "/static/img/user-8.jpg",
      name: "Elijah Garrett",
      designation: "",
      about:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem necessitatibus natus fugit porro at sunt mollitia repellendus deserunt, libero similique.",
        gallery:[
          "/static/img/user-1.jpg",
          "/static/img/user-2.jpg",
          "/static/img/user-3.jpg",
          "/static/img/user-4.jpg"
  
        ],
        status:"badge-success"
    }
]